exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-wrapper{flex-direction:column}.circle,.step-wrapper{display:flex;align-items:center}.circle{width:30px;height:30px;border-radius:50%;background-color:#ccc;color:#fff;justify-content:center;font-weight:700}.circle.active{background-color:#174b79}.line{width:18rem;height:4px;background-color:#ccc;margin:13px 5px 0}.label{margin-top:6px;font-size:.75rem;text-align:center;color:#555;max-width:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-717f7bb3","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms/config-guia.vue
// module id = 1045
// module chunks = 0